import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';

/* Actions */
import {
	setRequestCreditDetails,
	savePreviousReturnAndCreditDetails,
	sendEmailSuccessDialog,
	dropProductSpecsEmail
} from '../../../../redux/actions';

class RequestCreditStep1 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errorMessage: '',
			requestCreditDetails: null,
			scrapCreditOlderThan90DaysState:false,
			showLineLevelOlderThan90DaysIndex : -1,
			invoiceAge :"",
			scrapCreditOlderThan90DaysMessage: 'This request is older than allowed by the Return and Scrap Policy.',
			indexValue : []
		};
		this.handleDialog = this.handleDialog.bind(this);
	}
	componentDidMount() {
		window.scrollTo(0, 0);
		const self = this;
		// Redirect to request return page if there is no data in store, it means page is refreshed
		const relationShipTypes = self.props.user && self.props.user.relationShipPartyList && self.props.user.relationShipPartyList.responseObject && self.props.user.relationShipPartyList.responseObject.filter(party => party.RELATIONSHIP_STATUS === 'A').map(item => item.RELATIONSHIP_TYPE);
		const invoice = self.props.user && self.props.user.allTcaList && self.props.user.allTcaList.responseObject && self.props.user.allTcaList.responseObject.filter(item => relationShipTypes.includes(item.tcaRelationshipName));
		const defaultInvoice = self.props.user && self.props.user.allTcaList && self.props.user.allTcaList.responseObject && self.props.user.allTcaList.responseObject.filter(item => item.tcaRelationshipName === 'Default');
		const invoiceAge = invoice.length > 0 ? invoice[0].invoiceAge : defaultInvoice[0].invoiceAge;
		const { invoiceDate } = self.props.order.requestCreditDetails.responseObject;
		if(!self.props.order.requestCreditDetails) {
			browserHistory.push("/requestcredit");
		} else {
			let { requestCreditDetails, requestCreditFilterListOfOrders } = self.props.order;
			const items = [];
			const creditType = requestCreditFilterListOfOrders && requestCreditFilterListOfOrders.param ? requestCreditFilterListOfOrders.param.creditType: requestCreditDetails.responseObject.creditType;
			requestCreditDetails.responseObject.items = requestCreditDetails.responseObject.items.filter(item => item.invoiceNumber && item.lineStatus.toUpperCase() === 'CLOSED' && (item.lineType === "Standard Line" || item.lineType === "Bill Only Line"));
			requestCreditDetails.responseObject.items.forEach(item => {
				if(creditType === 'Delivery/Services/Fees' && self.props.checkItemIsServiceOrNot(item.item) === 'service') {
					items.push(item);
				} else if((creditType === 'Damage Allowances' || creditType === 'Scrap' || creditType === 'As-is Credit/Rebill' || creditType === 'Price Adjustment - Credit/Rebill') && self.props.getItemTypeByName(item.item) !== 'S') {
					items.push(item);
				}
			});
			requestCreditDetails.responseObject.items = items;
			self.setState({
				requestCreditDetails,
				creditType,
				invoiceAge:invoiceAge
			}, () => {
				if(invoiceDate && moment(invoiceDate).isBefore(moment().subtract(invoiceAge, 'days'), 'day') ) {
					if(creditType === 'Scrap'){
						self.setState({
							scrapCreditOlderThan90DaysState: true
						});
					}

				}
			});
		}
	}

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handleSelectProduct(indexx, event) {
		const self = this;
		let { requestCreditDetails } = self.state;
		const { typeOfUser } = self.props.user.userDetails;
		let { requestCreditFilterListOfOrders } = self.props.order;
		const creditType = requestCreditFilterListOfOrders && requestCreditFilterListOfOrders.param ? requestCreditFilterListOfOrders.param.creditType: '';
		let indexex = [...self.state.indexValue]
		if (event.target.checked) {
			if (!indexex.includes(indexx)) {
				indexex.push(indexx);
			}
		} else {
			if (indexex.includes(indexx)) {
				indexex.splice(indexex.indexOf(indexx), 1);
			}
		}
		requestCreditDetails.responseObject.items.forEach((item, index) => {
			if(index === indexx) {
				if( creditType === 'Scrap' && item.invoiceDate && moment(item.invoiceDate).isBefore(moment().subtract(self.state.invoiceAge, 'days'), 'day') ) {
					self.setState({
						showLineLevelOlderThan90DaysIndex : indexx
					});
					if(typeOfUser ==='employee') {
						item.selected = event.target.checked;
						item.returnQuantity = 1;
					}
				}else{
					item.selected = event.target.checked;
					item.returnQuantity = 1;	
				}
			}
		});
		self.setState({
			errorMessage: "",
			requestCreditDetails,
			indexValue:indexex
		})
	}

	updateParams(formName, event) {
		//Reseting Errors on change
		let error = this.state[formName].error;
		for (var key in error) {
			if (error.hasOwnProperty(key)) {
				error[key] = '';
			}
		}
		this.setState({
			[formName]: {
				param: {
					...this.state[formName].param,
					[event.target.name]: event.target.value
				},
				error
			},
		});
	}

	handleSelectQuantity(indexx, event) {
		const self = this;
		let { requestCreditDetails } = self.state;
		requestCreditDetails.responseObject.items.forEach((item, index) => {
			if(index === indexx) {
				item.returnQuantity = event.target.value
			}
		});
		self.setState({
			requestCreditDetails
		})
		// self.props.setRequestCreditDetails(requestCreditDetails);
	}

	handleCancel() {
		browserHistory.push("/requestcredit");
	}

	handleContinue() {
		const self = this;
		const { requestCreditDetails } = self.state;
		const selectedItems = _.filter(requestCreditDetails.responseObject.items, {selected: true});
		const selectedFlag = selectedItems.length > 0 ? true : false;
		if(!selectedFlag) {
			self.setState({
				errorMessage: "Please select at least one product."
			});
		} else {
			self.callBackContinue();
		}
	}

	callBackContinue() {
		const self = this;
		const { requestCreditDetails, creditType } = self.state;
		const items = [];
		requestCreditDetails.responseObject.items.forEach(itm => {
			items.push({
				...itm,
				originalSerialNumbers: itm.bkpSerialNumber,
				serialNumber: creditType === 'Delivery/Services/Fees' ? 'NA' : '',
			});
		});
		self.props.setRequestCreditDetails({
			responseObject: {
				...requestCreditDetails.responseObject,
				items,
				originalOrderNumber: requestCreditDetails.responseObject.orderNumber,
				shippingMethod: requestCreditDetails.responseObject.deliveryMethod,
				deliveryInstructions: "",
				requestedDeliveryDate: "",
				creditType
			}
		});
		browserHistory.push("/requestcreditstep2");
	}

	handleReturnLinesDetails(returnLines, orderNumber, event) {
		event && event.preventDefault();
		const self = this;
		self.props.savePreviousReturnAndCreditDetails({
			orderNumber,
			returnLines
		});
		browserHistory.push("/previousreturnandcredit");
	}

	isItemReturnable(item) {
		const self = this,
			returnableLineStatus = ['closed', 'awaiting fulfillment', 'awaiting receipt', 'picked', 'shipped'],
			{ creditType } = self.state;
		if(returnableLineStatus.indexOf(item.lineStatus.toLowerCase()) !== -1 &&
			(item.lineType.toLowerCase() === 'standard line' || item.lineType.toLowerCase() === 'bill only line') &&
			(creditType === 'Delivery/Services/Fees' || self.props.checkItemIsServiceOrNot(item.item) === 'product')
		) {
			return true;
		}

		return false;
	}

    render() {
		const self = this;
		const orderDetails = this.state.requestCreditDetails && this.state.requestCreditDetails.responseObject;
		const { userDetails} = self.props.user;
        return (
			<div>
			<div className="d-none d-sm-block">
		        <div className="push">
		        	<h1 className="pageTitle">Request Credit</h1>
		        </div>
				{orderDetails && !orderDetails.isValidBillTo && <p className="bold red">Due to a change in the Billing party/address on this account, this credit will need to be requested by the ASM through CREST and processed manually.</p>}
				{this.state.scrapCreditOlderThan90DaysState && <p className="bold red">
					{this.state.scrapCreditOlderThan90DaysMessage}
				</p>}
			   	 <div className="push">
					<p className="pad-b-1em">
						Select the product(s) for which you would like to receive credit.
					</p>
					<p className="bold red">{this.state.errorMessage}</p>
					<div className="captionAboveTable">
						<div className="columns">
							<div className="column column1">
								<b>CSO (Order number): {orderDetails && orderDetails.orderNumber}</b>
							</div>
							<div className="column column1">
								<b>Order Date: {orderDetails && orderDetails.orderDate && this.props.formatDate(orderDetails.orderDate, 'MM/DD/YY')}</b>
							</div>
							<div className="column column1">
								<b>P.O. # {orderDetails && orderDetails.poNumber}</b>
							</div>
						</div>
					</div>
					<table className="dataTable returnProductsOrderListTable">
						<thead>
							<tr>
								<th className="select">Select</th>
								<th className="product">Product</th>
								<th>Previous Returns/<br />Credits</th>
								<th className="quantityOrdered">Quantity<br />Ordered</th>
								<th className="quantityToReturn">Quantity<br />To Credit</th>
								<th className="invoiceNumber">Invoice #</th>
								<th className="invoiceDate">Invoice Date</th>
							</tr>
						</thead>
						<tbody>
							{orderDetails && orderDetails.items.map((item, index) => {
								if(!self.isItemReturnable(item)) return null;
								let alreadyReturnedQuantity = 0,
									availableQuantity = parseInt(item.quantity, 10);
								const returnLines = item.returnLines && item.returnLines.filter(itm => itm.lineType.toLowerCase() !== 'bill only line');
								if(returnLines && returnLines.length > 0) {
									alreadyReturnedQuantity = _.sumBy(returnLines, 'authorizedQty');
								}
								availableQuantity -= alreadyReturnedQuantity;
								return <tr key={index}>
									<td className="select">
										<input type="checkbox" disabled={!orderDetails.isValidBillTo || (alreadyReturnedQuantity < parseInt(item.quantity, 10) ? false : true)} onChange={this.handleSelectProduct.bind(this, index)} name="myQuantOrderReturn"  defaultChecked={item.selected}/>
									</td>
									<td className="product">{item.item}{self.state.showLineLevelOlderThan90DaysIndex == index ? <p className="bold red">{self.state.scrapCreditOlderThan90DaysMessage}</p>: ""}</td>
									<td>{returnLines && returnLines.length > 0 && <a href="" onClick={this.handleReturnLinesDetails.bind(this, returnLines, orderDetails.orderNumber)}>Click here</a>}</td>
									<td className="quantityOrdered">{item.quantity}</td>
									<td className="quantityToReturn">
									{item.selected && userDetails && (self.state.showLineLevelOlderThan90DaysIndex != index || userDetails.typeOfUser ==='employee')
									?<select onChange={this.handleSelectQuantity.bind(this, index)} name="returnQuantity" style={{width: 60}} defaultValue={item.returnQuantity}>
												{_.times(availableQuantity, (indx) => {
													return <option key={indx} value={indx+1}>{indx+1}</option>
												})}
											</select>
											:<input type="text" name="quantityToReturnFake" value="" style={{width: 60, display: 'inline-block'}} disabled />
										}
									</td>
									<td className="invoiceNumber">{item.invoiceNumber}</td>
									<td className="invoiceDate">{item.invoiceDate ? moment(item.invoiceDate).format('MM/DD/YYYY'):""}</td>
								</tr>
							})}
						</tbody>
					</table>
					<p className="floatLeft">
						<button id="cancelButton" onClick={this.handleCancel.bind(this)}>Cancel</button>
					</p>
					{userDetails && !(self.state.scrapCreditOlderThan90DaysState && userDetails.typeOfUser === "customer" )?
					<div>
					{orderDetails && orderDetails.isValidBillTo && <p className="floatRight">
						<button id="continueButton" onClick={this.handleContinue.bind(this)}>Continue</button>
					</p>}
					</div>:""}			
				</div>
			</div>

{/*Mobile view*/}

				<div className="d-block d-sm-none container">
					<div className="push">
						<h1 className="pageTitle">Request Credit</h1>
					</div>

					{orderDetails && !orderDetails.isValidBillTo && <p className="bold red requestCreditMessageFont">Due to a change in the Billing party/address on this account, this credit will need to be requested by the ASM through CREST and processed manually.</p>}
					{this.state.scrapCreditOlderThan90DaysState && <p className="bold red requestCreditMessageFont">
						{this.state.scrapCreditOlderThan90DaysMessage}
					</p>}

					<div className="push">
						<p className="pad-b-1em requestCreditMessageFont">
							Select the product(s) for which you would like to receive credit.
						</p>
					</div>

					<p className="bold red">{this.state.errorMessage}</p>

					<div className='container headerColor captionContainer'>
						<div className='row'>
							<div className='col-5 d-flex align-items-center'>
								<div>CSO (Order number): {orderDetails && orderDetails.orderNumber}</div>
								<div className="vr vrLinePosition vrLineWidth"></div>
							</div>
							<div className='col-4 d-flex align-items-center'>
								<div>
								Order Date: {orderDetails && orderDetails.orderDate && this.props.formatDate(orderDetails.orderDate, 'MM/DD/YY')}
								</div>
								<div className="vr vrLineWidth"></div>
							</div>
							<div className='col-3 d-flex align-items-center'>
								<div>
									P.O. # {orderDetails && orderDetails.poNumber}
								</div>
							</div>
						</div>
					</div>

					

					{orderDetails && orderDetails.items.map((item, index) => {
								if(!self.isItemReturnable(item)) return null;
								let alreadyReturnedQuantity = 0,
									availableQuantity = parseInt(item.quantity, 10);
								const returnLines = item.returnLines && item.returnLines.filter(itm => itm.lineType.toLowerCase() !== 'bill only line');
								if(returnLines && returnLines.length > 0) {
									alreadyReturnedQuantity = _.sumBy(returnLines, 'authorizedQty');
								}
								availableQuantity -= alreadyReturnedQuantity;
								return <div className="accordion removeAccBorder accordion-borderless" id={`accordionRequestReturnCreditStep1${index}`}  key={index}>
									<div className="accordion-item">

										<h2 className="accordion-header" id={`headingReturnStep1${index}`}>
											<div>
												<div className='row accBtn'>
													<div className='col-2 checkBoxDiv p-2'>
														<input 
															className="form-check-input requestCreditStep1CheckBox" 
															type="checkbox" 
															disabled={!orderDetails.isValidBillTo || (alreadyReturnedQuantity < parseInt(item.quantity, 10) ? false : true)} 
															onChange={this.handleSelectProduct.bind(this, index)} 
															name="myQuantOrderReturn"  
															defaultChecked={item.selected} 
															id={`checkbox-${index}`}
														/>
													</div>
													<div className='col-10'>
														<button className="accBtn accordion-button collapsed font-size-14" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseReturnStep1${index}`} aria-expanded="true" aria-controls={`collapseReturnStep1${index}`}>
															{`${index +1}.1 ${item.item}`} 
														</button>
													</div>
												</div>
											</div>
										</h2>	

										<div id={`collapseReturnStep1${index}`}
															className={`accordion-collapse collapse accBody ${(self.state.showLineLevelOlderThan90DaysIndex == index) ? 'accHeight350' : 'accHeight275'} ${this.state.indexValue.includes(index) ? 'show' : ''}`} 
															aria-labelledby={`headingReturnStep1${index}`}
															show>

											<div className="accBodyContainer">
												{(self.state.showLineLevelOlderThan90DaysIndex == index) && <div className="row ">
																	<p className="bold red requestCreditMessageFont">{self.state.scrapCreditOlderThan90DaysMessage}</p>
																		<hr className="hr hrSpec" />
																	</div>}
											
												<div className="row ">
													<div className="col-8 fw-bold">Previous Returns/Credits</div>
													<div className="col-4 text-end">{returnLines && returnLines.length > 0 && <a href="" onClick={this.handleReturnLinesDetails.bind(this, returnLines, orderDetails.orderNumber)}>Click here</a>}</div>
													<hr className="hr hrSpec" />
												</div>

												<div className="row ">
													<div className="col-8 fw-bold">Quantity Ordered</div>
													<div className="col-4 text-end">{item.quantity}</div>
													<hr className="hr hrSpec" />
												</div>

												<div className="row ">
													<div className="col-8 fw-bold pt-2">Quantity To Credit</div>
													<div className="col-4 text-end ">
														{item.selected && userDetails && (self.state.showLineLevelOlderThan90DaysIndex != index || userDetails.typeOfUser ==='employee')
														?
															<select onChange={this.handleSelectQuantity.bind(this, index)} className='form-select float-end' name="returnQuantity" defaultValue={item.returnQuantity}>
																{_.times(availableQuantity, (indx) => {
																	return <option key={indx} value={indx+1}>{indx+1}</option>
																})}
															</select>
															:<input type="text" name="quantityToReturnFake" className='accInput pt-2' value=""  disabled />
														}
													</div>
													<hr className="hr hrSpec" />
												</div>

												<div className="row ">
													<div className="col-8 fw-bold">Invoice #</div>
													<div className="col-4 text-end">{item.invoiceNumber}</div>
													<hr className="hr hrSpec" />
												</div>

												<div className="row ">
													<div className="col-8 fw-bold">Invoice Date</div>
													<div className="col-4 text-end">{item.invoiceDate ? moment(item.invoiceDate).format('MM/DD/YYYY'):""}</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							})}

					<p className="floatLeft">
						<button id="cancelButton" className='btnSize cancelButtonSpec' onClick={this.handleCancel.bind(this)}>Cancel</button>
					</p>
					{userDetails && !(self.state.scrapCreditOlderThan90DaysState && userDetails.typeOfUser === "customer" )?
					<div>
					{orderDetails && orderDetails.isValidBillTo && <p className="floatRight">
						<button id="continueButton" className='btnSize' onClick={this.handleContinue.bind(this)}>Continue</button>
					</p>}
					</div>:""}	
					
					<div style={{height:"200px"}}></div>
				</div>
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		order: state.order,
		user: state.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setRequestCreditDetails: (data) => dispatch(setRequestCreditDetails(data)),
	savePreviousReturnAndCreditDetails: (data) => dispatch(savePreviousReturnAndCreditDetails(data)),
	sendEmailSuccessDialog: (emailSendSuccessDialog) => dispatch(sendEmailSuccessDialog(emailSendSuccessDialog)),
	dropProductSpecsEmail: (payload, hybridQueryParams, callback) => dispatch(dropProductSpecsEmail(payload, hybridQueryParams, callback)),
});

RequestCreditStep1 = connect(mapStateToProps, mapDispatchToProps)(RequestCreditStep1);
export default RequestCreditStep1;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/RequestCredit/requestCreditStep1.js